module.exports = function() {

  return {
    template: require('html/templates/progressBar'),
    restrict: 'E',
    replace: true,
    scope: { max: '=', delivered: '=', deviation: '=', cancelled: '=' },
    link: function(scope) {
      scope.calcPercentage = function(count) {
        return (count / scope.max) * 100 + '%';
      };
      scope.isFirst = function(item) {
        if (item === 'cancelled') {
          return (scope.cancelled);
        } else if (item === 'delivered') {
          return (! scope.cancelled);
        } else if (item === 'deviation') {
          return (! scope.cancelled && ! scope.delivered);
        }
      };
      scope.isLast = function(item) {
        if (item === 'cancelled') {
          return (scope.cancelled === scope.max);
        } else if (item === 'delivered') {
          return (scope.cancelled + scope.delivered === scope.max);
        } else if (item === 'deviation') {
          return (scope.cancelled + scope.delivered + scope.deviation === scope.max);
        }
      };
    }
  };

};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/directives/progressBar.js
 ** module id = 154
 ** module chunks = 1
 **/